import { Badge } from '@chakra-ui/react'
import React from 'react'
import formatter from 'utils/formatter'

interface StatusBadgeProps {
    status: string
}

const statusColorScheme: Record<string, string> = {
    REGISTRADO: 'info', // Azul
    CANCELADO: 'yellow', // Amarelo
    BAIXADO: 'green', // Amarelo
    PROCESSANDO: 'grayscale' // Cinza
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const color = statusColorScheme[status] || 'gray'

    return (
        <Badge
            size="xl"
            w="full"
            textAlign="center"
            colorScheme={color}
            textTransform="initial"
            variant={status === 'PROCESSANDO' ? 'subtle' : 'solid'}
        >
            {formatter.firstLatterUppercase(status)}
        </Badge>
    )
}